<template>
  <div>
    <template v-if="$store.state.role === 'school-role' || $store.state.role === 'draw-role' || $store.state.role === 'education-role' || $store.state.role === 'view-role'">
    	<a-descriptions title="基本信息" :column="2" bordered>
	    <a-descriptions-item label="作品名称" :span="2">
	      {{info.zpname}}
	    </a-descriptions-item>
       <a-descriptions-item label="作品负责人" :span="2">
	      {{info.principals}}
	    </a-descriptions-item>
       <a-descriptions-item label="大赛分组" :span="2">
        <span v-if="info.levelType=='1'">
          中职组
        </span>
        <span v-if="info.levelType=='2'">
          高职组
        </span>
	    </a-descriptions-item>
       <!-- <a-descriptions-item label="团队类型" :span="2">
	     <span v-if="info.teamType=='teacher'">
          教师团队
        </span>
        <span v-if="info.teamType=='student'">
          学生团队
        </span>
	    </a-descriptions-item> -->
        
	    <!-- <a-descriptions-item label="省份" v-if="$store.state.role === 'school-role'">
	      {{info.provinceCode_dictText}}
	    </a-descriptions-item>
	    <a-descriptions-item label="省份" v-if="$store.state.role === 'education-role'">
	      {{info.provinceName}}
	    </a-descriptions-item>
	    <a-descriptions-item label="市" >
	       {{info.cityName}}
	    </a-descriptions-item> -->
	   <!-- <a-descriptions-item label="学校名称" :span="2">
        {{info.realname}}
     </a-descriptions-item>
	    <a-descriptions-item label="案例主持人"   v-if="$route.name=='alApply'">
        {{info.principals}}
     </a-descriptions-item>
      <a-descriptions-item label="案例联系人"   v-if="$route.name=='xal'">
        {{info.principals}}
     </a-descriptions-item>
      <a-descriptions-item label="联系电话">
        {{info.phone}}
     </a-descriptions-item> -->
      <a-descriptions-item label="团队成员" v-if="$route.name=='alApply'" :span="2">
        <template v-for="(tag) in tags">
            <span class="com-aspect text-center" :key="tag" >
              {{ tag }}
            </span>
          </template>
     </a-descriptions-item>
     <a-descriptions-item label="学校名称" :span="2">
        {{info.schoolName}}
     </a-descriptions-item>
     <a-descriptions-item label="学校意见" :span="2">
	      {{info.suggestion}}
	    </a-descriptions-item>
     </a-descriptions>
   </template>
   <template v-else>
   	 <a-descriptions title="基本信息" :column="2"  bordered>
   	 	<!-- <a-descriptions-item label="标题" :span="2">
        {{info.zpname}}
      </a-descriptions-item>
	    <a-descriptions-item label="省份" >
	      {{info.provinceName}}
	    </a-descriptions-item> -->

       <a-descriptions-item label="作品名称" :span="2">
	      {{info.zpname}}
	    </a-descriptions-item>
       <a-descriptions-item label="作品负责人" :span="2">
	      {{info.principals}}
	    </a-descriptions-item>
       <a-descriptions-item label="大赛分组" :span="2">
        <span v-if="info.levelType=='1'">
          中职组
        </span>
        <span v-if="info.levelType=='2'">
          高职组
        </span>
	    </a-descriptions-item>
      <a-descriptions-item label="团队成员"  v-if="$route.name=='alApply'" :span="2">
        <template v-for="(tag) in tags">
            <span class="com-aspect text-center" :key="tag" >
              {{ tag }}
            </span>
          </template>
     </a-descriptions-item>
     <a-descriptions-item label="学校意见" :span="2">
	      {{info.suggestion}}
	    </a-descriptions-item>
	     <!--<a-descriptions-item label="市" >
	      {{info.cityName}}
	     </a-descriptions-item>-->
	     <!--<a-descriptions-item label="学校名称" :span="2">
        {{info.realname}}
     </a-descriptions-item>-->
     <!--<a-descriptions-item label="案例主持人" >
	      {{info.principals}}
	    </a-descriptions-item>
	     <a-descriptions-item label="联系电话" >
        {{info.phone}}
     </a-descriptions-item>
      <a-descriptions-item label="团队成员" :span="2">
        <template v-for="(tag) in tags">
            <span class="com-aspect text-center" :key="tag" >
              {{ tag }}
            </span>
          </template>
     </a-descriptions-item>-->
     </a-descriptions>
   </template>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    editInfoStep1: {
      type: Object,
    },
  },
  data() {
    return {
      schoolType: Number(
        (JSON.parse(sessionStorage.getItem('userInfo') || 'null') || {}).schoolType
      ),
      info: {
        name: '',
        zpname:'',
        levelTypeText: '',
        levelType: '',
        major1:'',
        major1_dictText:"",
        major2:'',
        major2_dictText:"",
        major3:'',
        major3_dictText:"",
        phone: '',
        principals: '',
        teams: '',
      },
      major1Opt:'',
      major2Opt:'',
      major3Opt:'',
      levelTypeText: '',
      tags: [],
      inputVisible: false,
      inputValue: '',
    };
  },
  computed: {},
  watch: {},
  created() {
  	  this.info=this.editInfoStep1;
			if(this.editInfoStep1.teams && this.editInfoStep1.teams!= ''){
		     this.tags =this.editInfoStep1.teams.split(',');
			}
  },
  destroyed() {
  },
  mounted() {
  },
};
</script>

<style scoped lang="scss">
.mt30 {
  margin-top: 20px;
}
.main-text-style {
  font-size: 19px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 15px;
}
.input-style-2 {
  width: 100%;
  padding: 10px 20px;
  height: 54px;
  font-size: 18px !important;
  border: 1px solid #d9d9d9;
  color: #999999;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  margin-top: 50px;
  line-height: 38px;
  text-align: center;
  background: #9A0B00;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.com-aspect {
  min-width: 88px;
  font-size: 14px;
  position: relative;
  padding-right: 8px;
  line-height: 1.5px;
  /deep/ .anticon-close{
    position: absolute;
    top: 50%;
    right: 10px;
    transform:translateY(-50%);
  }
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
/deep/.com-aspect.ant-select > div {
  width: 100%;
  height: 100%;
  .ant-select-selection__rendered {
    font-size: 16px;
    line-height: 54px;
  }
}
</style>
